import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import '../assets/css/style.css';
import img from '../assets/css/img/frame1.png';
import img2 from '../assets/css/img/frame2.png';

const SolarSolutions = () => {
  return (
    <div className="solarenergy-solutions-container">
      <Row className="solar-solutions-row">
          <div className='col-md-1'></div>
          <div className='col-md-5'>
        <div className="solar-solutions-card left-column">
          <h2>How</h2>
          <p>Solar Solution Works?</p>
          {/* <Button variant="success" className="know-more-btn" style={{background:"#1AA323"}}>Know More</Button> */}
          <p style={{color:"#fff"}}>A solar solution converts sunlight into electricity using photovoltaic (PV) panels. These panels generate direct current (DC), which an inverter then converts to alternating current (AC) for use in homes or businesses. Excess energy can be stored in batteries or sent back to the grid, offering a sustainable, cost-effective power source.</p>
        </div>
        </div>
        <Col md={5} className="solar-solutions-card">
          <h2>Solar Solutions</h2>
          <p>can be deployed beyond rooftops as well</p>
          <div className="icon-text-wrapper">
            <div className="icon-text">
              <img src={img} alt="Lifetime service support" /><br/>
              {/* <span>Lifetime service support</span> */}
            </div>
            <div className="icon-text">
              <img src={img2} alt="Insurance for Solar" /><br/>
              {/* <span>Insurance for Solar</span> */}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SolarSolutions;
